import { useTranslations } from "@/lib/i18n/intl";
import { THEME_STATUS_LABEL_KEY } from "./theme-status";
import type { ThemeStatus } from "@/lib/api/types";
import { StatusDot, type DotTone } from "@/shared/rd";

const STATUS_TONE: Record<ThemeStatus, DotTone> = {
  DRAFT: "grey",
  PUBLISHED: "green",
  ARCHIVED: "amber",
};


/** A theme's lifecycle status: dot + word. */
export function ThemeStatusBadge({ status }: { status: ThemeStatus }) {
  const t = useTranslations();
  return <StatusDot tone={STATUS_TONE[status]}>{t(THEME_STATUS_LABEL_KEY[status])}</StatusDot>;
}
